/* eslint-disable no-undef */
const eventBus = window.theme.searchAutocomplete.eventBus

class SearchAutoCompleteAPILayer {
  constructor () {
    eventBus.subscribe('searchAutoComplete:state:term:updated', () => {
      this.fetchResults()
    })

    eventBus.subscribe(
      'searchAutoComplete:tracking:product:clicked',
      (productData) => {
        nostojs((api) => {
          api.recordSearchClick('autocomplete', {
            productId: productData.productId,
            url: productData.url,
          })
        })
      },
    )

    eventBus.subscribe(
      'searchAutoComplete:tracking:keyword:clicked',
      (keywordData) => {
        const { term } = keywordData
        const searchRequest = {
          query: term,
          products: {
            sort: [{ field: 'score', order: 'desc' }],
            filter: [],
          },
        }

        nostojs((api) => {
          api.recordSearch('autocomplete', searchRequest, {
            isKeyword: true,
          })
        })
      },
    )
  }

  async fetchResults () {
    nostojs((api) => {
      api
        .search(
          {
            query:
              window.theme.searchAutocomplete.stateLayer?.state?.term || '',
            products: {
              fields: [
                'name',
                'imageUrl',
                'alternateImageUrls',
                'price',
                'listPrice',
                'url',
                'skus.name',
                'skus.id',
                'skus.inventoryLevel',
              ],
              size: window.theme.categoryConfig.autoCompleteLimit,
            },
            keywords: {
              fields: ['keyword'],
              size: window.theme.categoryConfig.autoCompleteKeywordLimit,
            },
          },
          {
            track: 'autocomplete',
          },
        )
        .then((response) => {
          window.theme.searchAutocomplete.eventBus.publish(
            'searchAutoComplete:api:results:fetched',
            response,
          )
        })
    })
  }
}
window.theme.searchAutocomplete = window.theme.searchAutocomplete || {}

window.theme.searchAutocomplete.apiLayer = new SearchAutoCompleteAPILayer()
